var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDinners(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8384 19.2998H18.4345C22.4869 19.2998 25.7162 16.0848 25.8429 12.1133V12.0503C25.7795 8.01572 22.4869 4.73766 18.4345 4.8007H15.5218C11.6594 4.92678 8.62004 8.20484 8.74668 12.1133C8.74668 16.0217 11.9126 19.2368 15.8384 19.2998ZM10.0131 12.0503C10.0131 8.77223 12.7358 6.06152 16.0284 6.06152C19.321 6.06152 22.0437 8.77223 22.0437 12.0503C22.0437 15.3283 19.321 18.039 16.0284 18.039C12.7358 18.039 10.0131 15.3283 10.0131 12.0503ZM16.9782 16.0846V8.07861C19.1944 8.64597 20.5874 10.8524 20.0175 13.0587C19.6376 14.5717 18.4978 15.7064 16.9782 16.0846ZM12.1026 11.0415C11.5327 13.2479 12.8624 15.5173 15.0786 16.0846V8.07861C13.6223 8.45685 12.4825 9.59156 12.1026 11.0415Z",
    fill: "#0079BE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinners);
export default __webpack_public_path__ + "static/media/dinners.8c4b260b3aeb6125b56cef0ce35c9993.svg";
export { ForwardRef as ReactComponent };